import { EnumValueData } from "./reflectionTypes";

class ReflectionEnumValue {
	readonly Active: boolean;
	readonly $Name: string;
	private readonly _dependsOnValues: Set<string>;

	get active(): boolean {
		return this.Active;
	}

	get name(): string {
		return this.$Name;
	}

	isValidDependsOnValue(dependsOnValue: string): boolean {
		return !!this._dependsOnValues?.has(dependsOnValue);
	}

	constructor(item: EnumValueData, dependsOnValues: string[]) {
		this.$Name = item[0];
		this.Active = item[1];
		this._dependsOnValues = dependsOnValues ? new Set(dependsOnValues) : null;
	}
}

export default ReflectionEnumValue;